export default __webpack_public_path__ + "static/media/modal-close-button.d186d655.svg";